var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2654 3.5H17.5784C19.2487 3.5 20.6028 4.85408 20.6028 6.52442V17.4756C20.6028 19.1459 19.2487 20.5 17.5784 20.5H6.52442C4.85408 20.5 3.5 19.1459 3.5 17.4756V6.52442C3.5 4.85408 4.85408 3.5 6.52442 3.5H7.8888C7.88456 3.54785 7.88239 3.59629 7.88239 3.64524V8.06421C7.88239 9.40339 9.41203 10.1671 10.4824 9.36226L11.9808 8.23567C12.0247 8.20268 12.085 8.20246 12.1291 8.23514L13.6811 9.38477C14.753 10.1787 16.2719 9.4136 16.2719 8.07977V3.64524C16.2719 3.59629 16.2697 3.54785 16.2654 3.5ZM2 6.52442C2 4.02565 4.02565 2 6.52442 2H17.5784C20.0772 2 22.1028 4.02565 22.1028 6.52442V17.4756C22.1028 19.9743 20.0772 22 17.5784 22H6.52442C4.02565 22 2 19.9743 2 17.4756V6.52442ZM9.38239 3.64524C9.38239 3.57674 9.43792 3.52121 9.50643 3.52121H14.6478C14.7163 3.52121 14.7719 3.57674 14.7719 3.64524V8.07977C14.7719 8.18164 14.6558 8.24007 14.574 8.17944L13.022 7.02981C12.4443 6.60188 11.654 6.6047 11.0793 7.03676L9.58097 8.16335C9.49922 8.22481 9.38239 8.16649 9.38239 8.06421V3.64524ZM13.723 14.7506C13.723 14.4099 13.9992 14.1337 14.34 14.1337H19.2757C19.6164 14.1337 19.8927 14.4099 19.8927 14.7506C19.8927 15.0914 19.6164 15.3676 19.2757 15.3676H14.34C13.9992 15.3676 13.723 15.0914 13.723 14.7506ZM14.34 16.4473C13.9992 16.4473 13.723 16.7235 13.723 17.0643C13.723 17.405 13.9992 17.6812 14.34 17.6812H19.2757C19.6164 17.6812 19.8927 17.405 19.8927 17.0643C19.8927 16.7235 19.6164 16.4473 19.2757 16.4473H14.34Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.6935c97557b99274fd9884a0d35c288d.svg";
export { ForwardRef as ReactComponent };